import { useEffect, useState } from "react";
import { addAuthListener } from "../libs/auth";

/**
 * Bumps a counter whenever auth state changes (login, accounts / consumers
 * loaded, active consumer switched). `libs/auth` is a plain module store, so
 * components read it directly and use this only to re-render.
 */
export function useAuthVersion() {
  const [version, setVersion] = useState(0);
  useEffect(() => addAuthListener(() => setVersion((v) => v + 1)), []);
  return version;
}
